import { createContext, useCallback, useContext, useState } from 'react';

export const disableCandidateFormActionsContext = createContext(false);

export const DisableCandidateFormActionsProvider = ({ children }) => {
  // Track pending confirmations by uploadId (or a unique identifier)
  // If the Set has any items, form is disabled
  const [pendingConfirmations, setPendingConfirmations] = useState(new Set());
  const [disableActions, setDisableActions] = useState(false);

  const disableFormActions = useCallback(() => {
    setDisableActions(true);
  }, []);

  const enableFormActions = useCallback(() => {
    setDisableActions(false);
  }, []);

  // Register a pending confirmation (when ExtractedFieldsDisplay shows fields)
  const registerPendingConfirmation = useCallback(identifier => {
    setPendingConfirmations(prev => {
      const next = new Set(prev);
      next.add(identifier);
      return next;
    });
  }, []);

  // Unregister a pending confirmation (when confirmed or fields disappear)
  const unregisterPendingConfirmation = useCallback(identifier => {
    setPendingConfirmations(prev => {
      const next = new Set(prev);
      next.delete(identifier);
      return next;
    });
  }, []);

  // Form is disabled if there are any pending confirmations
  const disabled = pendingConfirmations?.size > 0 || false;

  return (
    <disableCandidateFormActionsContext.Provider
      value={{
        disableFormActions,
        enableFormActions,
        disabled,
        disableActions,
        disableActions,
        registerPendingConfirmation,
        unregisterPendingConfirmation,
        pendingCount: pendingConfirmations.size,
      }}>
      {children}
    </disableCandidateFormActionsContext.Provider>
  );
};

export const useDisableCandidateFormActions = () => {
  const context = useContext(disableCandidateFormActionsContext);
  if (context === undefined) {
    throw new Error(
      'useDisableCandidateFormActions must be used within a DisableCandidateFormActionsProvider',
    );
  }
  return context;
};
